import { z } from "zod";

/**
 * Forgot Password Form Validation Schema
 *
 * Validates:
 * - Email format and presence
 */
export const forgotPasswordSchema = z.object({
  email: z
    .string()
    .min(1, "passwordReset.forgot.errors.emailRequired")
    .email("passwordReset.forgot.errors.emailInvalid"),
});

/**
 * Reset Password Form Validation Schema
 *
 * Validates:
 * - Verification code (6 digits)
 * - New password strength (min 8 chars, uppercase, lowercase, number)
 * - Password confirmation match
 */
export const resetPasswordSchema = z
  .object({
    code: z
      .string()
      .length(6, "passwordReset.reset.errors.codeLength")
      .regex(/^\d+$/, "passwordReset.reset.errors.codeNumeric"),
    newPassword: z
      .string()
      .min(1, "passwordReset.reset.errors.passwordRequired")
      .min(8, "passwordReset.reset.errors.passwordTooShort")
      .regex(/[A-Z]/, "passwordReset.reset.errors.passwordNoUppercase")
      .regex(/[a-z]/, "passwordReset.reset.errors.passwordNoLowercase")
      .regex(/[0-9]/, "passwordReset.reset.errors.passwordNoDigit"),
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "passwordReset.reset.errors.passwordMismatch",
    path: ["confirmPassword"],
  });

/**
 * Type-safe form data types
 */
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
